import React, { Component } from "react";

import { tmxService } from "../../Services/TmxService.js";

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Input from '@material-ui/core/Input';

class TmxSearch extends Component {
	constructor(props) {
		super(props);
		this.handleDownloadTmx = this.handleDownloadTmx.bind(this);
		this.onFormSubmit = this.onFormSubmit.bind(this);
		this.onChange = this.onChange.bind(this);
		this.handleKey = this.handleKey.bind(this);
		this.searchTMX = this.searchTMX.bind(this);

		this.state={
			fase: (typeof this.props.tmx !=="undefined" && this.props.tmx!== null && this.props.tmx.length > 0) ? "load_tmx" : "empty",
			search: "",
			index: 0,
			found:-1
		}
	}
	
	handleDownloadTmx(){
		this.props.downloadTmx();
		this.setState({fase: "load_tmx"});
	}
	
	onFormSubmit(e){
		e.preventDefault();
		this.setState({index: 0});
		this.searchTMX(0);
	}
	
	searchTMX(index){
		var res;
		this.setState({fase: "searching"});
		if(this.state.search!==""){
			res = tmxService.search(this.props.tmx, this.state.search, index);
			if(res!==false){
				this.setState({found: res});
			}else{
				this.setState({found: false});
			}
		}else{
			this.setState({found: -1 });
		}
		this.setState({fase: "load_tmx"});
	}
	
	handleKey(e){
		if( (e.keyCode === 39) && e.altKey){
			e.stopPropagation();
			e.preventDefault();
			//console.log("NEXT TMX");
			this.searchTMX(this.state.index+1);
			this.setState({index: this.state.index+1});
		}else if( (e.keyCode === 37) && e.altKey){
			e.stopPropagation();
			e.preventDefault();
			//console.log("PREV TMX");
			if(this.state.index>0){
				this.searchTMX(this.state.index-1)
				this.setState({index: this.state.index-1});
			}
		}else if( (e.keyCode === 40) && e.altKey){
			e.stopPropagation();
			e.preventDefault();
			//console.log("insert from TMX");
		}
	}
	
	onChange(e){
		//this.setState({search: e.target.value});
		this.setState({index: 0, found: -1, search: e.target.value});
	}
	
	render() {
		//console.log("this.state: "+JSON.stringify(this.state));
		var content;
		switch(this.state.fase){
			case "empty":
				content = <span style={{cursor: "pointer"}} onClick={this.handleDownloadTmx}> TMX [ download ] </span>;
			break;
			case "searching":
			case "load_tmx":
				if(this.props.tmx!=null){
					let source="";
					let target="";
					if(this.state.fase==="searching"){
						source=<Box>SEARCHING[{this.state.index}]...</Box>
					}else{
						if(this.state.found!==false){
							if(this.state.found>-1){
								source=<Box class="tmx_seg">{this.props.tmx[this.state.found].segments[0].text}</Box>
								target=<Box class="tmx_seg">{this.props.tmx[this.state.found].segments[1].text}</Box>
							}
						}else{
							source=<Box>[ NOT FOUND ]</Box>
						}
					}
					content = <Box>
								<form onSubmit={this.onFormSubmit}>
									<div className="field">
										<input
										onKeyDown={this.handleKey}
										type="text"
										placeholder="Search TMX..."
										onChange={this.onChange}
										value={this.state.search}
										/>
									</div>
								</form>
								{source}
								{target}
							</Box>
				}else{
					content=<Box>Downloading...</Box>
				}
			break;
			default:
				content = "TMX";
		}
		return (
			<Box class="tmxSearch">{content}</Box>
		);
	}
}

export default TmxSearch;